export default "__VITE_ASSET__CDsX$VFY__"